import { isObject } from '../../../../util/object';
import { Flow } from '../model/flow.types';

interface ScrollToElementionOptions {
  skipHeaderPadding: boolean;
}

const getFlowScrollRef = (): HTMLIonContentElement | null => {
  const flowContainerEl = document.getElementsByClassName('flow-container');
  if (flowContainerEl.length > 0 && flowContainerEl[0]) {
    return flowContainerEl[0].closest('ion-content');
  } else {
    return null;
  }
};

const scrollToFlowDropZone = async () => {
  const itemEls = document.getElementsByClassName(`new-item`);
  const itemEl = itemEls[0] as HTMLDivElement;

  const scrollRef = getFlowScrollRef();
  if (scrollRef) {
    const placeholderEls = document.getElementsByClassName(`placeholder-item`);

    if (placeholderEls.length === 0) {
      return;
    }

    // if we have new items then scroll to the last one otherwise scroll to the first
    // placeholder
    const el = itemEl ? itemEls[itemEls.length - 1] : placeholderEls[0];

    if (el) {
      scrollToElement(el as HTMLElement);
    }
  }
};

const scrollToFlowItem = async (
  itemId: string,
  options?: ScrollToElementionOptions
): Promise<void> => {
  const els = document.getElementsByClassName(`item-${itemId}`);
  const el = els[0] as HTMLDivElement;

  if (el) {
    scrollToElement(el, options);
  }
};

const scrollToElement = async (
  el: HTMLElement,
  options?: ScrollToElementionOptions
): Promise<void> => {
  requestAnimationFrame(async () => {
    const scrollRef = getFlowScrollRef();

    let sectionHeaderHeight = 0;
    if (options?.skipHeaderPadding !== true) {
      sectionHeaderHeight = 56;
    }
    // we need to account for the possibility of a sticker header (section)
    const point = Math.max(0, el.offsetTop - sectionHeaderHeight);

    scrollRef?.scrollToPoint(0, point, 300);
  });
};

/**
 * Heuristic to determine if the given app data is of type Flow.
 */
const isFlowAppData = (appData: unknown): appData is Flow => {
  if (!isObject(appData)) {
    return false;
  }
  if (!('items' in appData && Array.isArray(appData.items))) {
    return false;
  }
  if (!('config' in appData && isObject(appData.config))) {
    return false;
  }
  return true;
};

export { scrollToFlowDropZone, scrollToFlowItem, isFlowAppData };
